import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/data-sources/page';

export const Route = createFileRoute('/_app/settings/data-sources/')({
  component: Page,
});
